import { qs } from '@fluorescent/dom';
import Delegate from 'ftdomdelegate';
import { emit } from '@/glow/events';

const selectors = {
  variantPopupTrigger: '[data-variant-popup-trigger]',
};

const variantPopup = node => {
  const delegate = new Delegate(node);

  const _variantPopupHandler = e => {
    e.preventDefault();

    const { modalContentId } = e.target.dataset;
    const content = qs(`#${modalContentId}`, node);

    emit('modal:open', null, {
      modalContent: content,
    });
  };

  const unload = () => {
    delegate.destroy();
  };

  delegate.on('click', selectors.variantPopupTrigger, _variantPopupHandler);

  return { unload };
};

export default variantPopup;
